import { FC } from 'react'
import { Box, Flex } from '@/components/atoms/Grid'
import CheckBox from '@/components/molecules/checkBox'
import styled from 'styled-components'

type TitledCheckboxProps = {
  isChecked: boolean
  onChanged: (value: boolean) => void
  isValid?: boolean
  TitleElement: () => JSX.Element
} & Rest

const TitledCheckbox: FC<TitledCheckboxProps> = ({
  isChecked,
  onChanged,
  isValid = true,
  TitleElement,
  ...rest
}) => {
  return (
    <>
      <Box width="100%">
        <StyledFlex
          justifyContent="flex-start"
          alignItems="center"
          my="5px"
          {...rest}
        >
          <CheckBox
            size={20}
            isChecked={isChecked}
            onCheckboxClick={() => onChanged(!isChecked)}
            isValid={isValid}
          />
          <TitleElement />
        </StyledFlex>
      </Box>
    </>
  )
}

export default TitledCheckbox

const StyledFlex = styled(Flex)`
  &:hover {
    cursor: pointer;
  }
`
